import { useRef } from "react";

const useInvoicesManager = ({
	invoices,
	invoicesBackup,
	setInvoices,
	setInvoicesBackup,
	position,
	setSelectedInvoice,
	noSelectedInvoice,
}) => {
	const selectedInvoiceRef = useRef();

	const setSelectedInvoiceSafe = (invoice) => {
		selectedInvoiceRef.current = invoice;
		setSelectedInvoice(invoice);
	};

	const onSubmitInvoiceChanges = (invoiceId, useBackupData = false) => {
		const collection = useBackupData ? invoicesBackup : invoices;

		setInvoices((prevInvoices) =>
			prevInvoices.filter((inv) => inv.id !== invoiceId)
		);
		setInvoicesBackup((prevBackup) =>
			prevBackup.filter((inv) => inv.id !== invoiceId)
		);
		
		if (selectedInvoiceRef.current?.id === invoiceId) {
			const currentIndex = collection.findIndex((inv) => inv.id === invoiceId);
			const updatedCollection = collection.filter((inv) => inv.id !== invoiceId);

			const nextInvoice =
				currentIndex + 1 < updatedCollection.length
					? updatedCollection[currentIndex]
					: null;

			setSelectedInvoiceSafe(nextInvoice || noSelectedInvoice(position));
		}
	};

	return { setSelectedInvoiceSafe, onSubmitInvoiceChanges };
};

export default useInvoicesManager;
